import { createEaterAuthTransport } from "./EaterAuthTransport";
// Module state rather than a DI singleton: Pendolino's eager bundle reads it without the
// container, and webpack shares the one module instance with the lazy chunks.
// The cookie is HttpOnly, so only Nova can tell; null until it answers.
let signedIn = null;
const listeners = new Set();
export function isEaterSignedIn() {
    return signedIn === true;
}
export function isEaterSessionKnown() {
    return signedIn !== null;
}
export function onEaterSignedInChange(listener) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
/**
 * Asks Nova for the session. A failed read leaves the state unknown rather than signed out.
 */
export function readEaterSession(locale) {
    return createEaterAuthTransport(locale)
        .session()
        .then((result) => {
        if (result.ok)
            setSignedIn(result.value !== null);
    });
}
export function rememberEaterSignedIn() {
    setSignedIn(true);
}
export function forgetEaterSignedIn() {
    setSignedIn(false);
}
function setSignedIn(next) {
    const was = signedIn;
    signedIn = next;
    if (was !== next)
        listeners.forEach((listener) => listener(next));
}
